import angular from "angular";
import {User} from "@common/model/user";
import {CacheService} from "@common/service/cache.service";
import {IUserService} from "@common/service/user.service";
import {TeamVaultService} from "@common/service/teamvault.service";
import {PushNotificationService} from "@common/service/push-notification.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {DocumentService} from "@common/service/document.service";
import {PermissionService} from "ecv/common/permissions";
import {IAppRootScopeService} from "@app/app.definition";
import {Service} from "@common/model/Service";
import {Discussion} from "@common/model/discussion";
import _ from "lodash";


export interface IEcvShare {
    openShareDocumentModal(doc: Document, deferred): boolean;

    init(): void;
}

class EcvShare implements IEcvShare {
    item: any;
    eligibleUsers: Array<User>;
    displayAs: string;
    subjectId: number;
    callback: Function;
    initialized: boolean = false;
    hardType: string;
    itemUsers: User[];
    title: string;
    existingDoc: boolean | string;
    itemType: string;
    sharedUsers: User[];
    crntUserId: number;
    itemShareable: Function;
    openShareItemModal: Function;
    currentUser;
    static $inject = ['$q', '$timeout', '$rootScope', 'TeamVaultService', 'UserService', '$_snackbar',
        'CacheService', 'DocumentService', 'BroadcastService', 'PushNotificationService', 'PermissionService'];

    constructor(
        private $q : ng.IQService,
        private $timeout : ng.ITimeoutService,
        private $rootScope: IAppRootScopeService,
        private $_team: TeamVaultService,
        private $_user: IUserService,
        private $_snack: any,
        private $_cache: CacheService,
        private $_document : DocumentService,
        private BroadcastService : BroadcastService,
        private $_pushNotificationService: PushNotificationService,
        private PermissionService : PermissionService
    ) {
        this.crntUserId = this.$_cache.getUser().id;
        this.currentUser = this.$_cache.getUser();
    }


    openShareDocumentModal = ($event, deferred): boolean => {
        if (this.shareable()) {
            $event.preventDefault();
            $event.stopPropagation();

            this.$rootScope.mainShowLoader = true;
            console.log("Opening share window:", this.item);
            if (!!this.openShareItemModal) {
                this.openShareItemModal(this.item).then(() => {
                    if (this.itemType == 'form') {
                        this.itemUsers = this.item.nonAssignors;
                    }
                });
            }
            this.$timeout(() => {
                deferred.resolve();
            }, 1000);
        } else {
            this.$timeout(() => {
                deferred.reject();
            }, 1000);
        }

        return true;
    }

    filter(user) {
        return !user.isFormerTeamMember && user.id != this.$_user.getMyId();
    }

    init(): void {

        // Creating a new document
        if (!this.item) {
            if (this.itemType == 'service') {
                this.item = new Service();
            } else {
                this.item = new Discussion().deserialize({permissionType: 'OWN'});
            }
        }
        if (this.itemType == 'post') {
            // Prefer the attribute subjectId
            if (!!this.subjectId) {
                this.item.subjectId = this.subjectId;
            }

            if (this.existingDoc == true || this.existingDoc == "true") {
                this.existingDoc = true;
            }
            this.sharedUsers = this.item.documentUsers;
        } else if (this.itemType == 'service') {
            this.sharedUsers = this.item.assignedUsers;
        }

        this.initialized = true;
    }

    shareable = (buttonClicked?): boolean => {
        if (!!buttonClicked) {
            this.item.hasNotificationUpdate = false;
            this.BroadcastService.broadcast('update-notification-array', [this.item.id]);
        }
        if (!!this.item) {
            if (!!this.itemShareable) {
                return this.itemShareable(this.item);
            } else {
                return this.initialized && !!this.item
                    && this.$_document.isPostShareable(this.item, this.item.subject, this.crntUserId);
                //isPostShareable is checking for permissions also
            }
        }
    }

    unshareableAlert = ($event, deferred): void => {
        $event.preventDefault();
        $event.stopPropagation();

        let sub = this.item.subject;
        let dispAs = this.displayAs == 'note' ? (!!this.item.hasAttachment && this.item.hasAttachment() || !!this.item.filename ? 'document' : 'discussion') : this.displayAs;
        let msg = this.$_document.getRestrictedSharingMsg(sub, this.item, dispAs, this.crntUserId);
        this.$_snack.success(msg);
        this.$timeout(() => {
            deferred.resolve();
        }, 1000);
    }

    showShareModal = (event) => {
        event = event || window.event;
        var deferred = this.$q.defer();
        if (_.includes(['DOCUMENT', 'DISCUSSION'], this.item.postType) && !this.item.viewed) {
            this.$_document.updateEntityViewed(this.item.postType, this.item.id);
        }
        if (!(this.shareable(true) && this.openShareDocumentModal(event, deferred))) {
            this.unshareableAlert(event, deferred);
        } else {
            this.$timeout(() => {
                deferred.resolve();
            }, 1000);
        }
        return deferred.promise;
    }

}

function export_func(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/share/components/shareIcon/share.directive.html',
        replace: true,
        controller: EcvShare,
        controllerAs: 'shareVm',
        bindToController: {
            'item': '=?ecvShareItem',
            'displayAs': '=displayAs',
            'subjectId': '=?ecvSubjectId',
            'callback': "=callback",
            'itemUsers': "=?itemUsers",
            'hardType': "@?hardType",
            'title': '=?title',
            'existingDoc': '@?existingDoc',
            'itemType': '@?itemType',
            'itemShareable': '=?itemShareable',
            'openShareItemModal': '=?openShareItemModal'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvShare): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.share').directive('ecvShare', export_func);
